export default {
  // Page title
  'page.title': 'ساعة توقيت',

  // How to use
  'howto.title': 'كيفية الاستخدام',
  'howto.step1': 'انقر على زر "ابدأ" لتشغيل ساعة التوقيت، تنسيق العرض: دقائق:ثواني.أجزاء من الثانية',
  'howto.step2': 'انقر على "إيقاف مؤقت" لإيقاف التوقيت عندما تكون ساعة التوقيت قيد التشغيل، انقر على "ابدأ" مرة أخرى للمتابعة',
  'howto.step3': 'انقر على زر "إعادة تعيين" لإعادة ساعة التوقيت إلى الصفر وإيقاف التوقيت',
  'howto.step4': 'تدعم ساعة التوقيت عرض دقة الميلي ثانية، مناسبة للسيناريوهات التي تتطلب توقيتاً دقيقاً',

  // User reviews
  'reviews.title': 'آراء المستخدمين',
  'reviews.michaelRunner': 'أداة تدريب أساسية! تتيح لي الدقة بالميلي ثانية تسجيل كل أداء سباق بدقة، عملية بسيطة وسريعة.',
  'reviews.chefJohnson': 'سحر مؤقت المطبخ! القلي السريع، غلي المعكرونة، طهي البيض بالبخار، كل ذلك يحتاج إلى توقيت دقيق، تساعدني ساعة التوقيت هذه على إعداد أطباق مثالية.',
  'reviews.sarahStudent': 'ضروري لمحاكاة الامتحان! يُستخدم لممارسة وقت الإجابة، الواجهة النظيفة لا تشتت الانتباه، حسّنت كفاءة الإجابة.',
  'reviews.coachWilliams': 'مساعد رائع لدورات التدريب! التدريب المتقطع وتمارين البلانك تحتاج إلى توقيت دقيق، الطلاب يحبونها.',
  'reviews.drAnderson': 'العمل الطبي غالباً يتطلب توقيتاً دقيقاً، ساعة التوقيت هذه بسيطة وموثوقة، مساعد رائع لعملي السريري.',

  // User names
  'user.michaelRunner': 'مايكل العداء',
  'user.chefJohnson': 'الشيف جونسون',
  'user.sarahStudent': 'سارة الطالبة',
  'user.coachWilliams': 'المدرب ويليامز',
  'user.drAnderson': 'د. أندرسون',

  // Keywords section
  'keywords.stopwatch': 'ساعة توقيت مؤقت توقيت دقيق كم الساعة الآن',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};